
import { defineComponent } from "vue";

import CargoPalletCatalogue from "@/components/catalogues/CargoPallet/CargoPalletCatalogue.vue";

export default defineComponent({
  components: { CargoPalletCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
